// src/components/cognition/cognition-domain-table.tsx
import React from "react";

export function CognitionDomainTable({ rows }: { rows: any[] }) {
  if (!rows?.length) return null;

  return (
    <div className="overflow-x-auto">
      <table className="w-full" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
        <thead>
          <tr>
            {["Domain", "Influence", "#Models", "Category", "Citations"].map((h, idx) => (
              <th
                key={h}
                className="px-4 py-3 text-left"
                style={{
                  backgroundColor: "var(--alpha-teal-10)",
                  borderTop: "1px solid var(--border)",
                  borderLeft: "1px solid var(--border)",
                  borderRight: idx === 4 ? "1px solid var(--border)" : undefined,
                  borderTopLeftRadius: idx === 0 ? "var(--radius)" : undefined,
                  borderTopRightRadius: idx === 4 ? "var(--radius)" : undefined,
                  fontSize: "var(--text-sm)",
                  fontWeight: "var(--font-weight-semibold)",
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((d: any, idx: number) => {
            const infl = Number(d?.influence ?? 0);
            const pct = Math.max(0, Math.min(100, (infl / 10) * 100));

            return (
              <tr key={`${d.domain}-${idx}`} className="table-row-hover">
                <td className="px-4 py-3" style={{ borderLeft: "1px solid var(--border)", borderTop: "1px solid var(--border)" }}>
                  {d.domain}
                </td>

                <td className="px-4 py-3" style={{ borderLeft: "1px solid var(--border)", borderTop: "1px solid var(--border)" }}>
                  <div className="flex items-center gap-3">
                    <div style={{ width: 80, height: 6, backgroundColor: "var(--muted)", borderRadius: 999, overflow: "hidden" }}>
                      <div style={{ width: `${pct}%`, height: "100%", backgroundColor: "var(--alpha-teal)" }} />
                    </div>
                    <span style={{ fontWeight: "var(--font-weight-semibold)" }}>{infl.toFixed(1)}</span>
                  </div>
                </td>

                <td className="px-4 py-3" style={{ borderLeft: "1px solid var(--border)", borderTop: "1px solid var(--border)" }}>
                  {d.models}
                </td>

                <td className="px-4 py-3" style={{ borderLeft: "1px solid var(--border)", borderTop: "1px solid var(--border)" }}>
                  {d.category}
                </td>

                <td
                  className="px-4 py-3"
                  style={{
                    borderLeft: "1px solid var(--border)",
                    borderTop: "1px solid var(--border)",
                    borderRight: "1px solid var(--border)",
                  }}
                >
                  {d.citations ?? 0}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
